export  function quoteSlider() {
    $(".quote-slider").each(function () {
        let curSliderWrap = $(this);
        let curSlider = curSliderWrap.find(".swiper-container");
		
        let swiperOptions = {
            watchOverflow: true,
            slidesPerView: 1,
            pagination: {
                el: `.${curSliderWrap.find(".swiper-pagination").attr("class")}`,
                clickable: true,
            }
        };

        let swiper = new Swiper(`.${curSlider.attr("class")}`, swiperOptions);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/quoteSlider.js